// Do not modify this file. It is overwritten in the publish pipeline to make module-version available to the runtime
export const version = '5.0.215'
